//import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  trang_thai: undefined, // required, enum(gui_yeu_cau, dang_tu_van, dang_san_xuat, dang_giao_hang, hoan_thanh, huy) - Trạng thái bản in
  // required - Thông tin đơn hàng
  don_hang: {
    da_chot_don: undefined, // required - Cho biết đã chốt đơn chưa
  },
  dong_ho_id: undefined, // required, ref: dong_ho - Mã dòng họ
  user_id: undefined, // required, ref: mushroom_user - Mã người dùng tạo yêu cầu in
  nguoi_dung_id: undefined, // required, ref: nguoi_dung - Mã người dùng tạo yêu cầu in
  node_id: undefined, // required, ref: node_gia_pha - Mã node gia phả gửi yêu cầu in
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo. Giống user_id nếu do người trong dòng họ tạo. Khác nếu là phía Việt Tộc tạo hộ
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  lich_su: [
    // optional - Lịch sử chuyển trạng thái
    {
      thoi_diem: undefined, // required - Thời điểm chuyển trạng thái
      trang_thai_truoc: undefined, // required, enum(gui_yeu_cau, dang_tu_van, dang_san_xuat, dang_giao_hang, hoan_thanh, huy) - Trạng thái trước khi chuyển
      trang_thai_sau: undefined, // required, enum(gui_yeu_cau, dang_tu_van, dang_san_xuat, dang_giao_hang, hoan_thanh, huy) - Trạng thái sau khi chuyển
      nguoi_chuyen_id: undefined, // required, ref: mushroom_user - Mã người chuyển trạng thái
    },
  ],
  // required - Thông tin cấu hình cho bản in
  cau_hinh: {
    ten_pha_do: undefined, // optional - Tên phả đồ trên cuốn thư
    ten_toc: undefined, // optional - Tên tộc trên cuốn thư
    dia_chi: undefined, // optional - Địa chỉ trên cuốn thư
    in_dau_re: undefined, // optional - In cả dâu, rể
    in_ngay_sinh: undefined, // optional - In ngày sinh
    in_ngay_gio: undefined, // optional - In ngày giỗ
    compact_layout_width: undefined, // optional - Co tối đa theo chiều rộng
    compact_layout_height: undefined, // optional - Co tối đa theo chiều cao
    theme: undefined, // optional, enum(pastel, co_dien) - Theme màu
    node_an_ids: [], // optional, array items: required - Danh sách các node ẩn
    node_goc_id: undefined, // optional, ref: node_gia_pha - Node gốc (không có thì mặc định là node trên cùng)
  },
  // required - Thông tin người liên hệ nhận bản in
  lien_he: {
    ho_ten: undefined, // required - Họ và tên
    dien_thoai: undefined, // required - Số điện thoại
    dia_chi: undefined, // optional - Địa chỉ người nhận hàng
  },
  // required - Bản mềm
  ban_mem: {
    anh_dai_dien_id: undefined, // optional, ref: mushroom_file - Mã ảnh thumbnail đại diện của bản in
    ban_in_id: undefined, // optional, ref: mushroom_file - Bản in, định dạng jpg hoặc pdf có đặt mật khẩu edit
    file_thiet_ke_id: undefined, // optional, ref: mushroom_file - File thiết kế AI
    file_watermark_id: undefined, // optional, ref: mushroom_file - File pdf có watermark và có đặt mật khẩu không cho edit và in
  },
  // optional - Thông tin bảo hành
  bao_hanh: {
    bat_dau: undefined, // optional - Ngày bắt đầu bảo hành
    ket_thuc: undefined, // optional - Ngày kết thúc bảo hành
    thoi_han: undefined, // optional - Thời hạn bảo hành. Ví dụ: '1 năm', '3 tháng'...
  },
  // optional - Thông tin thêm
  thong_tin: {
    so_node: undefined, // optional
    so_doi: undefined, // optional
  },
};

model.trangThai = [
  { value: "gui_yeu_cau", label: "Gửi yêu cầu" },
  { value: "dang_tu_van", label: "Đang tư vấn" },
  { value: "dang_san_xuat", label: "Đang sản xuất" },
  { value: "dang_giao_hang", label: "Đang giao hàng" },
  { value: "hoan_thanh", label: "Hoàn thành" },
  { value: "huy", label: "Hủy" },
];
model.trangThaiInGiaPhaSales_SalesManager = [
  { value: "gui_yeu_cau", label: "Gửi yêu cầu" },
  { value: "dang_tu_van", label: "Đang tư vấn" },
];

model.donHang = [
  { value: true, label: "Đã chốt đơn" },
  { value: false, label: "Chưa chốt đơn" },
];

model.theme = [
  { value: "pastel", label: "Hiện đại" },
  { value: "co_dien", label: "Cổ điển" },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],
  fields:
    "id,trang_thai,don_hang,dong_ho_id,user_id,nguoi_dung_id,node_id,nguoi_tao_id,thoi_diem_tao,lich_su,cau_hinh,lien_he,ban_mem,bao_hanh,thong_tin",
  dataSearch: {
    value: {
      "lien_he.dien_thoai": "",
      "don_hang.da_chot_don" : "",
    },
    valid: {
      ten: [],
      thoi_diem_tao: [],
    },
    operator: {
      "lien_he.dien_thoai": ":regex_i:",
      cong_khai: ":regex_i:",
    },
  },
};

export default model;
